import Notification from '../models/Notification';
import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

interface NotificationsState extends ApiState {
  notification?: Notification
}

export default requestReducer<NotificationsState>('UPDATE_NOTIFICATIONS')